import React from 'react'

const AllAds = () => {
    return (
        <>
            <div className=' display-mini display-mob'>
                <div className=" text-center mb-2">
                    <div className=" lh-sm">
                        <b className=" text-uppercase text-ads fst-italic fw-boldest letter-spacing-2 text-2xl">
                            Summer Sale
                        </b>
                    </div>
                    <div className=" mt-3">
                        <div className=" d-flex justify-content-center align-items-center gap-2">
                            <div className=" col-5">
                                <div className=" card border-radius-lg">
                                    <div className=" p-2 lh-1 mt-1">
                                        <div>
                                            <b className=" text-black fw-bolder fs-5 text-uppercase">
                                                Crazy
                                            </b>
                                        </div>
                                        <b className=" text-info fw-normal text-xxs fw-bolder letter-spacing-2 text-uppercase">
                                            Deals
                                        </b>
                                    </div>
                                    <div>
                                        <b className=" text-black fw-normal">Ice Cream</b>
                                        <div className=" mt-2">
                                            <img
                                                src="https://tropicalicecream.in/wp-content/uploads/2025/07/main-page-tropical-768x768.png"
                                                alt=""
                                                height={195}
                                                className=" object-fit-contain w-100"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className=" col-3">
                                <div className=" card border-radius-lg mb-2">
                                    <div className=" mt-2">
                                        <div className=" lh-1">
                                            <b className=" text-black fw-normal text-xxs">
                                                Skin & Self <br /> Care
                                            </b>
                                        </div>
                                        <div className=" mt-2">
                                            <img
                                                src="https://cdn.grofers.com/app/images/collections/asset_Skin_&_face_(1)_1710665369044"
                                                alt=""
                                                height={85}
                                                className=" object-fit-cover p-2 w-100"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className=" card border-radius-lg">
                                    <div className=" mt-2">
                                        <div className=" lh-1">
                                            <b className=" text-black fw-normal text-xs">
                                                Refreshing <br /> Coolers
                                            </b>
                                        </div>
                                        <div className=" mt-2">
                                            <img
                                                src="https://cdn.grofers.com/app/images/collections/asset_V7_312x360_(2)_1774455548692"
                                                alt=""
                                                height={85}
                                                className=" object-fit-cover p-1 w-100"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className=" col-3">
                                <div className=" card border-radius-lg mb-2">
                                    <div className="mt-2">
                                        <div className=" lh-1">
                                            <b className=" text-black fw-normal text-xs">
                                                Frozen <br /> Delights
                                            </b>
                                        </div>
                                        <div className=" mt-2">
                                            <img
                                                src="https://cdn.grofers.com/app/images/collections/asset_V7_312x360_(1)_1763118369111"
                                                alt=""
                                                height={85}
                                                className=" object-fit-cover p-2 w-100"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className=" card border-radius-lg">
                                    <div className="mt-2">
                                        <div className=" lh-1">
                                            <b className=" text-black fw-normal text-xs">
                                                Home <br /> & Apparel
                                            </b>
                                        </div>
                                        <div className=" mt-2">
                                            <img
                                                src="https://cdn.grofers.com/app/images/collections/asset_312x360_(2)_1752670450422"
                                                alt=""
                                                height={85}
                                                className=" object-fit-cover p-2 w-100"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AllAds